import BaseModelAPI from '../BaseModelAPI';

export default class ReportDailyProduction extends BaseModelAPI {
	static entity = 'newreport2003';
	static entityName = 'reportdailyproduction';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.filterWoNumber = '';
			this.filterPartNumber = '';
			this.filterMachine = '';
			this.filterProcessType = '';
			this.filterCustomer = '';
			this.filterLine = '';
			this.filterPartClassification = '';
			this.filterPeriodDate = '';
			this.tempId = 0;
			this.productionDate = '';
			this.workOrderProcessNumber = '';
			this.partNumber = '';
			this.customerName = '';
			this.qtyPlan = 0;
			this.lineName = '';
			this.processType = '';
			this.sequenceProcess = 0;
			this.totalProcess = 0;
			this.partClassification = '';
			this.shiftName = '';
			this.machineName = '';
			this.operatorUserName = '';
			this.actTtl = 0;
			this.actOk = 0;
			this.actOkRh = 0;
			this.actOkLh = 0;
			this.ng1Qty = 0;
			this.ng1RhNg = 0;
			this.ng1LhNg = 0;
			this.ng1KodeNg = 0;
			this.jamStart = 0;
			this.jamFinish = 0;
			this.jamMenit = 0;
			this.actSpm = 0;
			this.actSph = 0;
			this.downtimeDandori = 0;
			this.downtimeCheckQc = 0;
			this.downtimeMcCheck = 0;
			this.downtimeGantiPalet = 0;
			this.downtimeGantiMaterial = 0;
			this.downtimeGantiManPower = 0;
			this.downtimeTopCoilSet = 0;
			this.downtimeEndCoilSet = 0;
			this.losttimeDiestT = 0;
			this.losttimeDiesTDetails = 0;
			this.losttimeMct = 0;
			this.losttimeMctDetail = 0;
			this.losttimeQct = 0;
			this.losttimeQctDetail = 0;
			this.losttimeHt = 0;
			this.losttimeHtDetail = 0;
			this.losttimeFt = 0;
			this.losttimeFtDetail = 0;
			this.losttimeMt = 0;
			this.losttimeMtDetail = 0;
			this.losttimeDll = 0;
			this.losttimeDllDetail = 0;
			this.others3s = 0;
			this.othersMtg = 0;
			this.othersTry = 0;
			this.othersBreak = 0;
			this.total = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}